export default {
    RESET_STORE: 'RESET_STORE',
    SET_URL_PARAMETER: 'SET_URL_PARAMETER',
    SET_UI_LANGUAGE: 'SET_UI_LANGUAGE',
    SET_LOGGED_IN: 'SET_LOGGED_IN',
    // calls
    ADD_OR_UPDATE_CALL: 'ADD_OR_UPDATE_CALL',
    ADD_OR_UPDATE_CALL_REPLAY: 'ADD_OR_UPDATE_CALL_REPLAY',
    UPDATE_CALL_STATE: 'UPDATE_CALL_STATE',
    UPDATE_DATA: 'UPDATE_DATA',
    UPDATE_CALL: 'UPDATE_CALL',
    SELECT_CALL: 'SELECT_CALL',
    TIME_TRAVEL: 'TIME_TRAVEL',
    SET_CALLS_INITIALIZED: 'SET_CALLS_INITIALIZED',
    SET_DID_STATE: 'SET_DID_STATE',
    // messages
    ADD_OR_UPDATE_MESSAGE: 'ADD_OR_UPDATE_MESSAGE',
    UPDATE_MESSAGE_STATE: 'UPDATE_MESSAGE_STATE',
};
